import { streetSearchPoiDictionarySelector } from 'store/state/domainData/selectors';
import {
  makeMapStateToPropsFactory,
  PoiGetter,
} from 'components/cards/listing/makeMapStateToPropsFactory';
import { IBulletin, IProject } from 'utils/entities';
import UniversalCard  from 'components/cards/listing/UniversalCard';
import { connect } from 'react-redux';
import React from 'react';
import Carousel from 'ds/components/carousels/carousel';
import { ItemWrapper } from 'ds/components/carousels/carousel/styled';
import { Link } from 'components/link';
import { getLinkRouteParams } from 'ds/components/carousels/carousel/utils';
import { ShowAt } from 'consts/breakpoints';
import { State as RouteState } from 'config/routes';
import { routeByPoiType } from 'utils/marketplaceRoutes';

interface StreetNearbyCarouselProps {
  poi: Array<IBulletin | IProject>;
  isLoadingPoi: boolean;
  route: RouteState;
}

const streetPoiByIdSelector: PoiGetter = (state, id) => streetSearchPoiDictionarySelector(state)[id];
const makeStreetMapStateToProps = makeMapStateToPropsFactory(streetPoiByIdSelector);
const StreetConnectedUniversalCard = connect(makeStreetMapStateToProps)(UniversalCard);

export const StreetNearbyCarousel: React.FC<StreetNearbyCarouselProps> = ({ poi, isLoadingPoi, route }) => {
  if (!poi || !poi.length) return null;

  return (
    <ShowAt from={3}>
      {(hasArrows =>
          <Carousel hasArrows={hasArrows} isLoading={isLoadingPoi}>
            {poi.map(({ id, type }) => (
              <ItemWrapper key={id}>
                <Link
                  routeName={routeByPoiType(type)}
                  routeParams={getLinkRouteParams(id, route.params)}
                  hideLinkParams
                >
                  <StreetConnectedUniversalCard
                    id={id}
                    emptyLazyLoadPlaceholder
                  />
                </Link>
              </ItemWrapper>
            ))}
          </Carousel>
      )}
    </ShowAt>
  );
};
